module.exports = __webpack_public_path__ + "static/img/6.449b657.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_left_icon/6.png
// module id = V+nB
// module chunks = 1